import {Prop, Vue, Watch} from 'vue-property-decorator';
import BaseComponent from "@/core/components/BaseComponent";
import _ from 'lodash';

export default class BaseItemSearch extends BaseComponent {

    @Prop() value?: any;
    @Prop() multiple?: boolean;
    @Prop() label?: string;
    @Prop() disabled?: boolean;
    public loading = false;
    public search: string = "";
    protected defaultLabel = '';
    private debouncedSearch?: any;

    public created() {
        this.debouncedSearch = _.debounce(this.loadItem, 500);
    }

    public get selectMultiple(): boolean {
        return this.multiple ?? false;
    }

    public get labelText(): string {
        return this.label ?? this.defaultLabel;
    }

    public get isDisabled(): boolean {
        return this.disabled ?? false;
    }

    public set isDisabled(value: boolean) {
        this.disabled = value;
    }

    @Watch("search")
    private onSearchChange() {
        this.debouncedSearch();
    }

    protected loadItem() {
        // Override
    }

}
